'use strict';

import {changeLangToCurrent} from "../../components/langSwitcher/langSwitcher";
import {BaseElement} from "../BaseElement";

export class Button extends BaseElement {
  #textElement = null;
  constructor(text = null) {
    super('button');
    if (text)
      this.setText(text);
  }

  setText(text) {
    // if (this.#textElement)
    //   throw new Error('A text is already present, it should be removed before adding new');

    this.#textElement = new BaseElement('span')
      .addClass('language-string', 'text')
      .addAttribute('data-dictionary', text)
      .innerHtml(changeLangToCurrent(text))
      .appendTo(this.DOMElement);

    return this;
  }

  removeText() {
    this.#textElement.remove();

    return this;
  }

  addTextClass(...value) {
    // if (!this.#textElement)
    //   throw new Error('A text element is absent');

    this.#textElement.addClass(...value);

    return this;
  }

  removeTextClass(...value) {
    // if (!this.#textElement)
    //   throw new Error('A text element is absent');

    this.#textElement.removeClass(...value);

    return this;
  }
}
